import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";
import { ManagerType } from "../constants";

export default {
  path: "/organization",
  redirect: "/organization",
  name: "Organization",
  component: LAYOUT,
  meta: {
    order: 20,
    roles: ManagerType.ProjectAdmin,
    title: "机构管理",
  },
  children: [
    {
      path: "",
      name: "OrganizationPage",
      component: () => import("../../views/organization/OrganizationPage.vue"),
      meta: {
        title: "机构管理",
        icon: "fluent:organization-20-regular",
        roles: ManagerType.ProjectAdmin,
      },
    },
  ],
} as RouteRecordRaw;
